import { cloudFunctionsService } from '@/data/services/cloudFunctionsService';
import type { JsonObject } from '@/data/types/json';

/**
 * GetUserPrivateJwkUseCase
 *
 * Retrieves the user's private JWK for encryption/decryption.
 * Returns raw JWK object - no remapping needed for key material.
 */
export class GetUserPrivateJwkUseCase {
    async execute(): Promise<JsonObject | null> {
        return await cloudFunctionsService.getUserPrivateJwk();
    }
}

export const getUserPrivateJwkUseCase = new GetUserPrivateJwkUseCase();
